// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_banner__DXuTW {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 36px;
  padding: 0.4rem 0.75rem;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
  color: var(--color-white);
  padding-top: calc(0.4rem + env(safe-area-inset-top, 0px));
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  animation: style_slideDown__FDvx4 0.25s ease-out;
}

.style_offline__C\\+C0I {
  background: var(--color-red);
}

.style_online__gFF-k {
  background: var(--color-green);
}

.style_icono__nHWoH {
  font-size: 1rem;
  flex-shrink: 0;
}

.style_texto__zOVR1 {
  overflow: hidden;
  text-overflow: ellipsis;
}

@keyframes style_slideDown__FDvx4 {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./../../shared/src/componets/feedback/ConnectionBanner/style.module.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EAEA,gBAAA;EACA,uBAAA;EAEA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,yDAAA;EAEA,yCAAA;EACA,gDAAA;AANJ;;AASA;EACI,4BAAA;AANJ;;AASA;EACI,8BAAA;AANJ;;AASA;EACI,eAAA;EACA,cAAA;AANJ;;AASA;EACI,gBAAA;EACA,uBAAA;AANJ;;AASA;EACI;IACI,4BAAA;EANN;EAQE;IACI,wBAAA;EANN;AACF","sourcesContent":["// Barra fija de estado de conexión. Mobile-first.\n// Se monta por encima del header (z-index alto) en el borde superior de la pantalla.\n.banner {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 1100; // por encima del header fijo (z-index: 100)\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n\n    min-height: 36px;\n    padding: 0.4rem 0.75rem;\n\n    font-size: 0.8rem;\n    font-weight: 600;\n    line-height: 1.2;\n    text-align: center;\n    color: var(--color-white);\n\n    padding-top: calc(0.4rem + env(safe-area-inset-top, 0px));\n\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n    animation: slideDown 0.25s ease-out;\n}\n\n.offline {\n    background: var(--color-red);\n}\n\n.online {\n    background: var(--color-green);\n}\n\n.icono {\n    font-size: 1rem;\n    flex-shrink: 0;\n}\n\n.texto {\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n@keyframes slideDown {\n    from {\n        transform: translateY(-100%);\n    }\n    to {\n        transform: translateY(0);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": `style_banner__DXuTW`,
	"slideDown": `style_slideDown__FDvx4`,
	"offline": `style_offline__C+C0I`,
	"online": `style_online__gFF-k`,
	"icono": `style_icono__nHWoH`,
	"texto": `style_texto__zOVR1`
};
export default ___CSS_LOADER_EXPORT___;
